import { render, staticRenderFns } from "./SharingSummary.vue?vue&type=template&id=07bfc916&scoped=true&"
import script from "./SharingSummary.vue?vue&type=script&lang=ts&"
export * from "./SharingSummary.vue?vue&type=script&lang=ts&"
import style0 from "./SharingSummary.vue?vue&type=style&index=0&id=07bfc916&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bfc916",
  null
  
)

export default component.exports